import type { ReactNode } from 'react';
import type { Placement } from 'react-bootstrap/types';
import { BsQuestionCircleFill, BsQuestionCircle } from 'react-icons/bs';

import BayTooltip from '../../BayTooltip';

interface HelpIconProps {
	content?: string | ReactNode;
	filled?: boolean;
	placement?: Placement;
	trigger?: string | string[];
	tooltipClassName?: string;
	color?: string;
}

const HelpIcon = ({
	content,
	filled = false,
	placement = 'top',
	trigger = ['hover', 'focus'],
	tooltipClassName,
	color = 'var(--bs-gray-500)',
}: HelpIconProps) => {
	// BayTooltip accepts string trigger, so convert array to string
	const triggerValue = Array.isArray(trigger) ? trigger[0] : trigger;

	return (
		<BayTooltip
			overlay={
				<div id="tooltip-help-icon" style={{ maxWidth: 280 }}>
					{content}
				</div>
			}
			overlayClassName={tooltipClassName}
			placement={placement}
			trigger={triggerValue}
			inverseStyle={false}
		>
			<span className="d-flex align-items-center justify-content-center text-500">
				{filled ? (
					<BsQuestionCircleFill color={color} />
				) : (
					<BsQuestionCircle color={color} />
				)}
			</span>
		</BayTooltip>
	);
};

export default HelpIcon;
